import React from 'react';

import ruleNames, { RuleNames } from '../../../constants/ruleNames';

import Default from '../ruleParamsSummaries/Default';
import DatapointConflictParams from '../ruleParamsSummaries/DatapointConflictParams';
import SimpleAnomalyDetection from '../ruleParamsSummaries/SimpleAnomalyDetection';
import SimpleAnomalyDetectionWithoutWindow from '../ruleParamsSummaries/SimpleAnomalyDetectionWithoutWindow';
import DueDiligence from '../ruleParamsSummaries/DueDiligence';
import MerchantCategoryCode from '../ruleParamsSummaries/MerchantCategoryCode';
import MultipleIpCountries from '../ruleParamsSummaries/MultipleIpCountries';
import IPCountryAllowlist from '../ruleParamsSummaries/IPCountryAllowlist';
import SustainedForeignIpCountry from '../ruleParamsSummaries/SustainedForeignIpCountry';
import AmountThreshold from '../ruleParamsSummaries/AmountThreshold';
import CategorizationThreshold from '../ruleParamsSummaries/CategorizationThreshold';
import TransactionThreshold from '../ruleParamsSummaries/TransactionThreshold';
import TransactionMonitoringTypicalAmount from '../ruleParamsSummaries/TransactionMonitoringTypicalAmount';

export type RuleParams = React.FC<{}>;

const mapRuleParamsSummary: Record<RuleNames, RuleParams> = {
  [ruleNames.ADDITIONAL_DELIVERY_ADDRESS]: Default,
  [ruleNames.ADVERSE_MEDIA]: Default,
  [ruleNames.AFFORDABILITY]: Default,
  [ruleNames.AGE_THRESHOLD]: Default,
  [ruleNames.ALWAYS_TRIGGER]: Default,
  [ruleNames.AMOUNT_THRESHOLD]: AmountThreshold,
  [ruleNames.ANOMALY_DETECTION_INCOMING_AVERAGE]: SimpleAnomalyDetection,
  [ruleNames.ANOMALY_DETECTION_INCOMING_FREQUENCY]: SimpleAnomalyDetection,
  [ruleNames.ANOMALY_DETECTION_INCOMING_SINGLE_AMOUNT]: SimpleAnomalyDetectionWithoutWindow,
  [ruleNames.ANOMALY_DETECTION_INCOMING_VOLUME_ROLLING_SUM]: SimpleAnomalyDetection,
  [ruleNames.ANOMALY_DETECTION_OUTGOING_AVERAGE]: SimpleAnomalyDetection,
  [ruleNames.ANOMALY_DETECTION_OUTGOING_FREQUENCY]: SimpleAnomalyDetection,
  [ruleNames.ANOMALY_DETECTION_OUTGOING_SINGLE_AMOUNT]: SimpleAnomalyDetectionWithoutWindow,
  [ruleNames.ANOMALY_DETECTION_OUTGOING_VOLUME_ROLLING_SUM]: SimpleAnomalyDetection,
  [ruleNames.ANOMALY_DETECTION_PROCESSING_AVERAGE]: SimpleAnomalyDetection,
  [ruleNames.ANOMALY_DETECTION_PROCESSING_FREQUENCY]: SimpleAnomalyDetection,
  [ruleNames.ANOMALY_DETECTION_PROCESSING_SINGLE_AMOUNT]: SimpleAnomalyDetectionWithoutWindow,
  [ruleNames.ANOMALY_DETECTION_PROCESSING_VOLUME_ROLLING_SUM]: SimpleAnomalyDetection,
  [ruleNames.ANOMALY_DETECTION_TOTAL_AVERAGE]: SimpleAnomalyDetection,
  [ruleNames.ANOMALY_DETECTION_TOTAL_FREQUENCY]: SimpleAnomalyDetection,
  [ruleNames.ANOMALY_DETECTION_TOTAL_SINGLE_AMOUNT]: SimpleAnomalyDetectionWithoutWindow,
  [ruleNames.ANOMALY_DETECTION_TOTAL_VOLUME_ROLLING_SUM]: SimpleAnomalyDetection,
  [ruleNames.ANOMALY_DETECTION]: Default,
  [ruleNames.BUSINESS_ACTIVE]: Default,
  [ruleNames.BUSINESS_AUDITOR]: Default,
  [ruleNames.BUSINESS_DATA_CHANGED]: Default,
  [ruleNames.BUSINESS_EQUITY_SHARE]: Default,
  [ruleNames.BUSINESS_EQUITY]: Default,
  [ruleNames.BUSINESS_FINANCIAL_STATEMENT_COMMENT]: Default,
  [ruleNames.BUSINESS_FTAX]: Default,
  [ruleNames.BUSINESS_PAYMENT_APPLICATIONS_SUM]: Default,
  [ruleNames.BUSINESS_PAYMENT_APPLICATIONS]: Default,
  [ruleNames.BUSINESS_PAYMENT_REMARKS_SUM]: Default,
  [ruleNames.BUSINESS_PAYMENT_REMARKS]: Default,
  [ruleNames.BUSINESS_PROVIDER_WARNING]: Default,
  [ruleNames.BUSINESS_SANCTION_LIST]: Default,
  [ruleNames.BUSINESS_VAT]: Default,
  [ruleNames.CAR_FREQ_HISTORICAL_OWNERS]: Default,
  [ruleNames.CAR_GUARANTOR_RELATED]: Default,
  [ruleNames.CAR_IN_CIRCULATION]: Default,
  [ruleNames.CAR_VALUATION]: Default,
  [ruleNames.CASH_FLOW]: Default,
  [ruleNames.CATEGORIZATION_AMOUNT_THRESHOLD]: Default,
  [ruleNames.CO_ADDRESS]: Default,
  [ruleNames.COLLECTOR]: Default,
  [ruleNames.CONNECTED_BUYER_SELLER]: Default,
  [ruleNames.CONNECTED_ENTITY_PEP]: Default,
  [ruleNames.CONNECTED_ENTITY_SANCTION_LIST]: Default,
  [ruleNames.COUNTRY_CITIZENSHIP_BLACKLIST]: Default,
  [ruleNames.COUNTRY_RESIDENCE_BLACKLIST]: Default,
  [ruleNames.COUNTRY_RESIDENCE_WHITELIST]: Default,
  [ruleNames.CREDIT_RISK]: Default,
  [ruleNames.DATAPOINT_CONFLICT]: DatapointConflictParams,
  [ruleNames.DETECT_NEW_IP]: Default,
  [ruleNames.DUE_DILIGENCE]: DueDiligence,
  [ruleNames.EMPLOYMENT_TYPE]: Default,
  [ruleNames.ENTITY_CONNECTED_ACCOUNT_COUNT]: Default,
  [ruleNames.FOREIGN_ADDRESS]: Default,
  [ruleNames.INCOMING_CATEGORIZATION_FREQUENCY]: CategorizationThreshold,
  [ruleNames.INCOMING_CATEGORIZATION_ROLLING_SUM]: CategorizationThreshold,
  [ruleNames.INCOMING_FREQUENCY]: TransactionThreshold,
  [ruleNames.INCOMING_VOLUME_ROLLING_SUM]: TransactionThreshold,
  [ruleNames.INDIVIDUAL_CRIMINAL_RECORD]: Default,
  [ruleNames.INDIVIDUAL_PEP]: Default,
  [ruleNames.INDIVIDUAL_SANCTION_LIST]: Default,
  [ruleNames.IP_ANONYMOUS]: Default,
  [ruleNames.IP_COUNTRY_ALLOWLIST]: IPCountryAllowlist,
  [ruleNames.IP_COUNTRY_BLACKLIST]: Default,
  [ruleNames.KYC_VALID]: Default,
  [ruleNames.LOW_INCOME]: Default,
  [ruleNames.MERCHANT_CATEGORY_CODE_BLOCKLIST]: MerchantCategoryCode,
  [ruleNames.MULTIPLE_IP_COUNTRIES]: MultipleIpCountries,
  [ruleNames.OUTGOING_CATEGORIZATION_FREQUENCY]: CategorizationThreshold,
  [ruleNames.OUTGOING_CATEGORIZATION_ROLLING_SUM]: CategorizationThreshold,
  [ruleNames.OUTGOING_FREQUENCY]: TransactionThreshold,
  [ruleNames.OUTGOING_VOLUME_ROLLING_SUM]: TransactionThreshold,
  [ruleNames.PROCESSING_FREQUENCY]: TransactionThreshold,
  [ruleNames.PROCESSING_VOLUME_ROLLING_SUM]: TransactionThreshold,
  [ruleNames.RELATED_INDIVIDUALS_CRIMINAL_RECORD]: Default,
  [ruleNames.SELLER_OWNS_CAR]: Default,
  [ruleNames.SHARED_IP_ENTITY_COUNT]: Default,
  [ruleNames.ENTITY_DISTINCT_IP_COUNT]: Default,
  [ruleNames.SUSTAINED_FOREIGN_IP_COUNTRY]: SustainedForeignIpCountry,
  [ruleNames.SNI_CODE_BLACKLIST]: Default,
  [ruleNames.SOURCE_OF_FUNDS]: Default,
  [ruleNames.SOURCE_OF_INCOME]: Default,
  [ruleNames.SPAR_CHANGED]: Default,
  [ruleNames.SUSPICIOUS_FUNDS]: Default,
  [ruleNames.TEST_BLOCK]: Default,
  [ruleNames.TEST_REVIEW]: Default,
  [ruleNames.TIME_WINDOW]: Default,
  [ruleNames.TOTAL_CATEGORIZATION_FREQUENCY]: CategorizationThreshold,
  [ruleNames.TOTAL_CATEGORIZATION_ROLLING_SUM]: CategorizationThreshold,
  [ruleNames.TOTAL_FREQUENCY]: TransactionThreshold,
  [ruleNames.TOTAL_VOLUME_ROLLING_SUM]: TransactionThreshold,
  [ruleNames.TRANSACTION_NAME_MATCHING]: Default,
  [ruleNames.INVOICE_PAID_BY_ISSUER]: Default,
  [ruleNames.TRANSACTION_MONITORING_TYPICAL_AMOUNT]: TransactionMonitoringTypicalAmount,
  [ruleNames.ZIP_CODE_BLACKLIST]: Default,
};

export default mapRuleParamsSummary;
